<template>
  <div class="temp-user-data_block">
    <TableBox :is-with-header="false" :table-contents="userData"/>
  </div>
</template>

<script>
  import TableBox from "@/components/molecules/box/TableBox";

  export default {
    name: "UserDataTable",

    components: {TableBox},


    props: {
      userDetail: {
        type: Object,
        required: true
      },
      office: {
        type: Object,
        required: true
      },
    },

    computed: {
      userData() {
        return {
          name: {
            dt: '名前',
            dd: `${this.userDetail.lastName}${this.userDetail.firstName}`,
          },
          isOwner: {
            dt: '事務所名',
            dd: this.office.name,
          },
          officePostCode: {
            dt: '事務所郵便番号',
            dd: this.office.postcode,
          },
          officeAddress: {
            dt: '事務所住所',
            dd: this.office.address,
          },
          officePhoneNumber: {
            dt: '事務所電話番号',
            dd: this.office.phoneNumber,
          },
        }
      },
    },

  }
</script>

<style lang="scss" scoped>
  .temp-user-data_block {
    .large_label {
      margin: 4rem 0 2rem 0;
    }

    .table_box {
      margin: 2rem 0;
      width: 100%;
    }

    > .blue-ellipse_button {
      margin-top: 6rem;
      width: 100%;
    }
  }
</style>